import { object } from "prop-types";
import { StoryElement, WithLazy, SocialShare } from "@quintype/components";
import get from "lodash/get";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { SvgIconHandler } from "../../../atoms/svg-icon-hadler";
import AttachmentElement from "../custom-story-elements/attachment-element";
import ImageGalleryElement from "../custom-story-elements/gallery-element";
import ReferenceElement from "../custom-story-elements/reference-element";
import ShareAllTemplate from "../story-info/story-meta-icons/social-share-template/share-all-template";
import SlideshowElement from "../custom-story-elements/slideshow-element";

import "./story-card.m.css";

const StoryCard = ({ story, card }) => {
  const [showPopup, setPopup] = useState(null);

  useEffect(() => {
    if (!document) return null;
    const documentNodes = document.getElementsByTagName("a") || [];
    const anchors = Array.from(documentNodes);
    anchors.forEach((anchor) => {
      if (anchor.hostname && anchor.hostname !== window.location.hostname) {
        anchor.setAttribute("target", "_blank");
      }
    });
  }, []);

  const elementId = get(
    card,
    ["story-elements"].map((element) => element.id),
    ""
  );
  const [clickId, setclickId] = useState(elementId);
  const getlisticleStoryCardStyle = () => {
    if (story["story-template"] === "listicle") {
      const listicleStoryCardStyle = { marginTop: "16px" };
      return listicleStoryCardStyle;
    }
    return {};
  };

  const templates = {
    file: AttachmentElement,
  };

  const imagePosition = get(card, ["metadata", "attributes", "imageposition", 0], "");

  const imageAlign = () => {
    let style;
    switch (imagePosition) {
      case "left align":
        style = "left-align";
        break;

      case "right align":
        style = "right-align";
        break;

      default:
        style = "";
        break;
    }
    return style;
  };

  const langCode = useSelector((state) => get(state, ["qt", "config", "publisher-attributes", "lang"], ""));
  const summaryElement = card["story-elements"].map((element) => element.type === "summary");
  const banglaSummaryStoryCard = langCode === "bn" && summaryElement ? "bangla-summary-story-card" : "";

  const [isOpinionCard] = get(card, ["metadata", "attributes", "opinion"], ["false"]);

  const OpinionCard = function ({ card }) {
    return (
      <div styleName="opinion-card-wrapper">
        <div styleName="opinion-card">
          {card["story-elements"].map((element) => {
            if (element.subtype === "blockquote") {
              let imageUrl = "";
              if (element.metadata.member) {
                imageUrl = element.metadata.member["avatar-url"];
              }
              return (
                <div styleName="opinion-card-heading">
                  <img src={imageUrl} styleName="opinion-card-image" />
                  <StoryElement element={element} story={story} renderTemplates={templates} loadIframeOnClick />
                </div>
              );
            } else {
              return <StoryElement element={element} story={story} renderTemplates={templates} loadIframeOnClick />;
            }
          })}
        </div>
      </div>
    );
  };

  const lang = useSelector((state) => get(state, ["qt", "config", "publisher-attributes", "lang"], "en"));

  const storyCardStyle = `story-card ${banglaSummaryStoryCard} ${lang}-story-card`;

  return isOpinionCard === "true" ? (
    <OpinionCard card={card} />
  ) : (
    <div styleName={storyCardStyle} style={getlisticleStoryCardStyle()}>
      {card["story-elements"].map((element, index) => {
        const imageElementStyle =
          element.type === "image" &&
          card["story-elements"].length > index + 1 &&
          card["story-elements"][index + 1].type === "text" &&
          !card["story-elements"][index + 1].subtype
            ? imageAlign()
            : "";

        const getImageDetails = () => {
          if (story["story-template"] === "photo") {
            if (element.title) {
              const imageDetails = { display: "flex", justifyContent: "space-between" };
              return imageDetails;
            } else {
              const imageDetails = { display: "flex", justifyContent: "end" };
              return imageDetails;
            }
          }
        };
        const toggleShareTemplate = (photoId) => {
          setclickId(photoId);
          return setPopup(!showPopup);
        };
        const Share = (props) => {
          return (
            <button styleName="button" aria-label="social-share">
              <span
                onClick={() => {
                  toggleShareTemplate(element.id);
                }}
              >
                <SvgIconHandler type="black-share" width="24" height="24" viewBox="0 0 24 24" />
              </span>
              {showPopup && clickId === element.id && <ShareAllTemplate setPopup={setPopup} {...props} />}
            </button>
          );
        };

        const potraitImageStyle = () => {
          if (
            element.type === "image" &&
            element["image-metadata"] &&
            element["image-metadata"].width < element["image-metadata"].height &&
            !(
              card["story-elements"].length > index + 1 &&
              card["story-elements"][index + 1].type === "text" &&
              !card["story-elements"][index + 1].subtype
            )
          ) {
            return {
              display: "flex",
              justifyContent: "center",
            };
          }

          return {};
        };

        const getMarginStyles = () => {
          if (element.type === "image" && element.title) {
            return "";
          }

          return "add-margin-bottom";
        };
        if (element.type === "image" || element.type === "jsembed" || element.type === "youtube-video") {
          return (
            <div className={imageElementStyle}>
              <WithLazy margin="50px">
                {() => (
                  <>
                    <div style={potraitImageStyle()} styleName={getMarginStyles()}>
                      <StoryElement
                        id={element.id}
                        element={element}
                        key={element.id}
                        story={story}
                        renderTemplates={templates}
                        loadIframeOnClick
                      />
                    </div>
                    <div style={getImageDetails()}>
                      {element.type === "image" && (
                        <>
                          {element.title && (
                            <div styleName="caption-wrapper" className="caption-wrapper">
                              <figcaption styleName="caption" dangerouslySetInnerHTML={{ __html: element.title }} />
                              {element["image-attribution"] && <> |</>}
                              {element["image-attribution"] && (
                                <span
                                  styleName="attribute"
                                  dangerouslySetInnerHTML={{ __html: `${element["image-attribution"]}` }}
                                />
                              )}
                            </div>
                          )}
                          {get(story, ["story-template"]) === "photo" && (
                            <SocialShare
                              template={Share}
                              title={story.headline}
                              fullUrl={encodeURI(`${get(story, ["url"], "")}?cardId=${get(card, ["id"], -1)}`)}
                              cardShare={true}
                            />
                          )}
                        </>
                      )}
                    </div>
                  </>
                )}
              </WithLazy>
            </div>
          );
        }

        if (element.subtype === "references") {
          const referenceObj = get(element, ["story-elements"], []);
          return referenceObj.map((element, index) => {
            return <ReferenceElement element={element} key={index} />;
          });
        }

        if (element.subtype === "image-gallery") {
          if (element.metadata.type === "gallery") {
            return <WithLazy margin="50px">{() => <ImageGalleryElement story={story} element={element} />}</WithLazy>;
          }

          if (element.metadata.type === "slideshow") {
            return <WithLazy margin="50px">{() => <SlideshowElement story={story} element={element} />}</WithLazy>;
          }
        }

        return (
          <StoryElement
            element={element}
            key={element.id}
            story={story}
            renderTemplates={templates}
            loadIframeOnClick
            styleName={langCode === "bn" && element.type === "summary" ? "translated-summary-text" : ""}
          />
        );
      })}
    </div>
  );
};

StoryCard.propTypes = {
  card: object,
  story: object,
};

export default StoryCard;
